import React from 'react';
export const WeekStartDateContext = React.createContext<Date>(null);

export const useWeekStartDate = () => {
  const weekStartDate = React.useContext(WeekStartDateContext);

  return weekStartDate;
};
